import * as React from "react";
import Layout from "./component/Layout";
import Home from "./page/Home";
import About from "./page/About";
import DetailPage from "./page/DetailPage";
import SummaryTablePage from "./page/SummaryTablePage";
import SummaryCardPage from "./page/SummaryCardPage";
import { Routes, Route } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import TableViewIcon from "@mui/icons-material/TableView";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import { ThemeProvider } from "./context/ThemeState";

const App = () => {
  const navLinks = [
    { titleI18nId: "home", to: "/", icon: <HomeIcon /> },
    { titleI18nId: "nav1", to: "/tablestyle", icon: <TableViewIcon /> },
    {
      titleI18nId: "nav2",
      to: "/cardstyle",
      icon: <DashboardCustomizeIcon />,
    },
    { titleI18nId: "about", to: "/about", icon: <EmojiEmotionsIcon /> },
  ];

  return (
    <ThemeProvider>
      <Layout navLinks={navLinks}>
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/tablestyle" element={<SummaryTablePage />} />
          <Route path="/cardstyle" element={<SummaryCardPage />} />
          <Route path="/products/detail/:id" element={<DetailPage />} />
          <Route path="/" element={<Home />} />
        </Routes>
      </Layout>
    </ThemeProvider>
  );
};

export default App;
